import { render, staticRenderFns } from "./TaskComment.vue?vue&type=template&id=5c1cc0bb&"
import script from "./TaskComment.vue?vue&type=script&lang=js&"
export * from "./TaskComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports